// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/servicos_categorias/delete
 *
 * Deletes a service category.
 */
import { registerContract } from './validate'

export interface ServicosCategorias_DeleteInput {
servicoscategoria_id: number
}

registerContract('ServicosCategorias_DeleteInput', {
  servicoscategoria_id: { type: 'number',  required: true },
})
